export default __webpack_public_path__ + "static/media/taxi.b51cdacb.svg";